<template>
<div id="campaign-config" class="mkt-ops -main-font">
    <div class="md-layout-item md-size-100" style="margin-bottom: 10px;">
        <label class="title">CONFIG NOTIFICATION</label>
    </div>

    <div id="table-campaign-config">
        <div id="divHeadList">
            <div style="width: 20%;">Set Notification</div>
            <div style="width: 45%">Message</div>
            <div style="width: 15%">Send Date</div>
            <div style="width: 10%" class="-text-center">Send time</div>
            <div style="width: 10%;" class="-text-center">Status</div>
        </div>
        <div id="divBodyList">
            <div :class="'row-bg-gray -pointer'" v-for="(item, rIndex) in config" :key="rIndex" @click="editConfig(item)">
                <div style="width: 20%;" class="nowrap-title">
                    <div :title="item.detail" class="font-bold">{{ item.title }}</div>
                    <div :title="item.detail">{{ item.detail }}</div>
                </div>
                <div style="width: 45%;" class="-font-kanit" :title="item.template">{{ item.template }}</div>
                <div style="width: 15%;">{{ item.run_date }}</div>
                <div style="width: 10%;" class="-text-center">{{ item.run_time }}</div>
                <div style="width: 10%;" class="font-bold -text-center">{{ item.status }}</div>
            </div>
        </div>
        <!-- <div class="footer-table">number of lines in page ({{tbListProduct.length}})</div> -->
    </div>

    <md-dialog :md-active.sync="showdlgEdit" class="mkt-ops -main-font dialog-campaign-config" :md-click-outside-to-close="false">
        <md-dialog-title>Config Message</md-dialog-title>

        <div class="layout-dialog">
            <div class="md-layout -dialog-contant">
                <md-field>
                    <label>Title</label>
                    <md-input v-model="form.title"></md-input>
                </md-field>
                <md-field>
                    <label>Detail</label>
                    <md-input v-model="form.detail"></md-input>
                </md-field>
                <md-field>
                    <label>Message</label>
                    <md-input class="-font-kanit" v-model="form.template"></md-input>
                </md-field>

                <div><label>Send Date</label></div>
                <div class="display-mode">{{form.run_date}}</div>
                <md-field>
                    <label>Send time</label>
                    <md-input v-model="form.run_time"></md-input>
                </md-field>
                <md-field>
                    <label>Status</label>
                    <md-select v-model="form.status">
                        <md-option value="Active">Active</md-option>
                        <md-option value="Inactive">Inactive</md-option>
                    </md-select>
                </md-field>
            </div>
        </div>
        <!-- <md-dialog-content>
            <md-field>
                <label>Title</label>
                <md-input v-model="form.title"></md-input>
            </md-field>
            <md-field>
                <label>Detail</label>
                <md-input v-model="form.detail"></md-input>
            </md-field>
            <md-field>
                <label>Message</label>
                <md-input v-model="form.template"></md-input>
            </md-field>
            <md-field>
                <label>Send Date</label>
                <md-input v-model="form.run_date" disabled></md-input>
            </md-field>
            <md-field>
                <label>Send time</label>
                <md-input v-model="form.run_time"></md-input>
            </md-field>
            <md-field>
                <label>Status</label>
                <md-select v-model="form.status">
                    <md-option value="Active">Active</md-option>
                    <md-option value="Inactive">Inactive</md-option>
                </md-select>
            </md-field>
        </md-dialog-content> -->

        <md-dialog-actions class="-action">
            <div class="md-empty-row"></div>
            <div class="md-button">
                <md-button class="md-primary -cancel" @click="onClickCancel()">CANCEL</md-button>
                <md-button class="md-primary -confirm" @click="saveConfig">SAVE</md-button>
            </div>
        </md-dialog-actions>
    </md-dialog>

    <md-dialog-confirm style="font-family: lato;" :md-active.sync="showdlgConfig" md-content="Confirm save change." md-confirm-text="OK" md-cancel-text="Cancel" @md-confirm="confirmSave" />
    <md-dialog-alert style="font-family: lato;" :md-active.sync="showAlert" md-content="Please all input." />
</div>
</template>

<script>
import CampaignService from "@/services/campaign";
import moment from "moment-timezone";

export default {
    name: "CampaignReport",
    data: () => ({
        showdlgEdit: false,
        showdlgConfig: false,
        showAlert: false,
        search: null,
        searched: [],
        config: [],
        form: {
            _id: '',
            title: '',
            detail: '',
            template: '',
            run_date: '',
            run_time: '',
            status: ''
        }
    }),
    methods: {
        onClickCancel() {
            this.showdlgEdit = false;
        },
        editConfig(item) {
            this.form._id = item._id;
            this.form.title = item.title;
            this.form.detail = item.detail;
            this.form.template = item.template;
            this.form.run_date = item.run_date;
            this.form.run_time = item.run_time;
            this.form.status = item.status;
            this.showdlgEdit = true;
        },
        saveConfig() {
            if (this.form.title == '' ||
                this.form.detail == '' ||
                this.form.template == '' ||
                this.form.run_date == '' ||
                this.form.run_date == ''
            ) {
                this.showAlert = true;
                return;
            }
            this.showdlgConfig = true;
        },
        confirmSave() {
            CampaignService.saveConfig(this.form).then(res => {
                this.loadConfig();
                this.showdlgEdit = false;
            });
        },
        loadConfig() {
            CampaignService.getConfig().then(res => {
                this.config = res;
            });
        }
    },
    created() {
        this.loadConfig();
    }
};
</script>

<style lang="scss">
#campaign-config {
    background-color: #fff;
    padding: 18px 18px;
    font-family: lato;

    .row-bg-gray:hover {
        border-radius: 4px;
        background: rgba(236, 236, 235, 1);

        &.-pointer {
            cursor: pointer;
        }
    }

    .title {
        font-size: 18px;
        font-weight: bold;
        color: #797979;
    }

    #table-campaign-config {
        #divHeadList {
            width: 99.6%;
            display: -webkit-inline-box;
            font-size: 13px;
            font-weight: bold;
            margin-top: 15px;
            margin-bottom: 13px;

            div {
                // border: 1px solid pink;
                padding-left: 5px;
                padding-right: 5px;

                &.-text-right {
                    text-align: right;
                }

                &.-text-center {
                    text-align: center;
                }
            }
        }

        #divBodyList {
            width: 100%;
            height: calc(100vmin - 118px);
            display: block;
            overflow-y: scroll;

            >div {
                width: 100%;
                // height: 35px;
                // display: -webkit-inline-box;
                display: flex;
                padding-top: 6px;
                padding-bottom: 6px;
                // border: 1px solid pink;

                div {
                    // border: 1px solid pink;
                    display: table;
                    padding-left: 5px;
                    padding-right: 5px;

                    &.-text-right {
                        text-align: right;
                    }

                    &.-text-center {
                        text-align: center;
                    }

                    &.nowrap-title {
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        padding-left: 0px;
                    }

                    &.font-bold,
                    .font-bold {
                        font-weight: bold;
                    }
                }
            }

            &::-webkit-scrollbar {
                height: 7px;
                width: 5px;
            }
        }

        .footer-table {
            // border: 1px solid pink;
            display: block;
            text-align: center;
            margin-top: 5px;
            width: 99.6%;
            font-size: 14px;
            font-style: italic;
        }
    }
}

.dialog-campaign-config {
    &.md-dialog {
        max-height: unset;
    }

    width: 100%;
    height: 80%;
    z-index: 6;
    transform: unset !important;
    top: 10% !important;
    left: 10% !important;

    .md-dialog-title {
        &.md-title {
            font-size: 18px;
            margin-bottom: 5px;
            padding: 21px 30px 0;
            font-weight: bold;
        }

        .title-panel {
            position: fixed;
        }
    }

    .dialog-content {
        padding: 20px;
    }

    .-action {
        position: fixed;
        padding: 8px 20px 10px 24px;
        bottom: 0px;
        margin-right: auto;
        margin-left: auto;
        width: 100%;
        justify-content: flex-start;

        .md-empty-row {
            width: 70%;
        }

        .md-button {
            width: 30%;
            text-align: right;
            justify-content: flex-end;
        }

        .md-button:not([disabled]):hover:before {
            background-color: unset;
        }

        .-cancel {
            color: #A8A8A8 !important;
            font-weight: bold;
            font-size: 16px;
        }

        .-confirm {
            color: #3F51B5;
            font-weight: bold;
            font-size: 16px;
            margin-left: 10px;
        }
    }

    .layout-dialog {
        padding: 15px 15px 5px 25px;

        // .layout-input-value {
        //     .md-has-value>label {
        //         color: #727272;
        //     }

        //     .display-mode {
        //         font-size: 16px;
        //         color: #000000;
        //         margin-top: 4px;

        //         &.nowrap-title {
        //             white-space: nowrap;
        //             overflow: hidden;
        //             text-overflow: ellipsis;
        //             display: block;
        //         }
        //     }
        // }

        .-dialog-contant {
            width: 100%;
            height: calc(80vmin - 120px);
            display: block;
            overflow-y: scroll;
            padding: 10px;

            label {
                font-size: 12px;
                color: rgb(148, 148, 150);
                font-family: lato;
                font-weight: bold;
            }

            .display-mode {
                font-size: 16px;
                color: #000000;
                margin-top: 4px;
                margin-bottom: 24px;

                &.nowrap-title {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: block;
                }
            }

            &::-webkit-scrollbar {
                height: 7px;
                width: 5px;
            }
        }

    }
}
</style>
